const TRANSLATIONS_EN = {
    calibrated: 'Calibrated',
    eventTypeFieldLabel: 'Event type',
    eventTypeIsRequired: 'Event type is required',
    inspected: 'Inspected',
    replaced: 'Replaced',
    serviced: 'Serviced'
};

export default TRANSLATIONS_EN;
